import axios from 'axios'
import Cookies from 'js-cookie'

export function isProd () {
  //return true
  return window.location.href.includes('://zhenwoai.com')
}

export function isLocal () {
  return false
  const url = window.location.href
  if (url.includes('://local.zhenwoai.cn')) return true
  return url.includes('://127.0.0.1') || url.includes('://localhost') || url.includes('://192.168.')
}

export const LOCAL_WEB_URL = 'http://127.0.0.1'
export const LOCAL_API_URL = 'http://localhost:9529/v1'
export const LOCAL_WSAPI_URL = 'ws://localhost:9529/v1'

export const TEST_WEB_URL = 'https://zhenwoai.cn'
export const TEST_API_URL = 'https://zapi.zhenwoai.cn/v1'
export const TEST_WSAPI_URL = 'wss://zapi.zhenwoai.cn/v1'

export const PROD_WEB_URL = 'https://zhenwoai.com'
export const PROD_API_URL = 'https://api.zhenwo.vip/v1'
export const PROD_WSAPI_URL = 'wss://api.zhenwo.vip/v1'

export const WEB_URL = isProd() ? PROD_WEB_URL : (isLocal() ? LOCAL_WEB_URL : TEST_WEB_URL)
export const API_URL = isProd() ? PROD_API_URL : (isLocal() ? LOCAL_API_URL : TEST_API_URL)
export const WSAPI_URL = isProd() ? PROD_WSAPI_URL : (isLocal() ? LOCAL_WSAPI_URL : TEST_WSAPI_URL)
export const CALLBACK_URL = isProd() ? 'https://callback.zhenwo.vip' : 'https://zcallback.zhenwoai.cn'

export const THE_ICP_STR = isProd() ? '沪ICP备2023024407号-2' : '沪ICP备2023024407号-3'
export const THE_WAN_NUM = 31011702888922
export const THE_WAN_STR = `沪公网安备${THE_WAN_NUM}`

export function setAccessToken (access_token) {
// 获取当前域名
  const domainParts = window.location.hostname.split('.')
  const domain = domainParts.length > 2 ? domainParts.slice(-2).join('.') // 处理二级域名
    : window.location.hostname // 主域名
  console.info(domain)
  Cookies.set('access_token', access_token, { expires: 30, path: '/', domain: `.${domain}` })

}

export function getAccessToken () {
  return Cookies.get('access_token', { path: '/' })
}

export function clearAllCookies () {
  const allCookies = Cookies.get() // 获取所有cookies
  for (let cookie in allCookies) {
    Cookies.remove(cookie, { path: '/' }) // 删除每一个cookie
  }
}

export async function fastCreateApi (fun) {
  try {
    const rsp = await fun
    return rsp.data
  } catch (error) {
    throw error
  }
}

export function fastBuildHeader () {
  return {
    'accept': 'application/json', 'access-token': getAccessToken(),
  }
}

export function fastCreateConfig (params = {}) {
  return {
    headers: fastBuildHeader(), params: params,
  }
}

export async function fastGetApi (url, params = {}) {
  return await fastCreateApi(axios.get(url, fastCreateConfig(params)))
}

export async function fastPostApi (url, params = {}, data = {}) {
  return await fastCreateApi(axios.post(url, data, fastCreateConfig(params)))
}

export async function fastDeleteApi (url, params = {}) {
  return await fastCreateApi(axios.delete(url, fastCreateConfig(params)))
}

export async function fastPutApi (url, params = {}, data = {}) {
  return await fastCreateApi(axios.put(url, data, fastCreateConfig(params)))
}

export async function getBrainPlazaList () {
  return await fastPostApi(`${API_URL}/brain/plaza/list`)
}

export async function getBrainChatOnlines (brain_id) {
  return await fastPostApi(`${API_URL}/chat/onlines`, {}, { brain_id })
}

export async function sendPlazaAction (brain_id, action_tyle, action) {
  return await fastPostApi(`${API_URL}/brain/plaza/action`, {}, {
    brain_id: brain_id, action_type: action_tyle, action: action,
  })
}

export async function getPlazaBrainActions () {
  return await fastGetApi(`${API_URL}/plaza/customer/actions`)
}

export async function loginByPassword (account, passwd) {
  return await fastPostApi(`${API_URL}/customer/login`, {}, {
    account: account, passwd: passwd,
  })
}

export async function getUserInfo () {
  return await fastGetApi(`${API_URL}/customer/info`, {})
}

export async function getThirdUserInfo (type, unionid) {
  return await fastGetApi(`${API_URL}/customer/third/info`, { auth_type: type, union_id: unionid })
}

export async function getOtherUserInfo (uid) {
  return await fastGetApi(`${API_URL}/customer/public-info`, { uid: uid })
}

export async function getUserWallet () {
  return await fastGetApi(`${API_URL}/wallet/customer/info`)
}

export async function getUserBrainList () {
  return await fastGetApi(`${API_URL}/brain/branch/list`, {})
}

export async function getUserBrainInfo (sayid) {
  return await fastGetApi(`${API_URL}/brain/branch/info`, { say_id: sayid })
}

export async function getBrainInfoAno (sayid) {
  return await fastGetApi(`${API_URL}/brain/branch/ano/info`, { say_id: sayid })
}

export async function getBrainListV2 (category) {
  return await fastGetApi(`${API_URL}/brain/plaza/list-v2`, { category: category })
}

export async function getBrainPublicInfo (sayid) {
  return await fastGetApi(`${API_URL}/brain/public-info`, { say_id: sayid })
}

export async function getKnowledgeDocLeftspace () {
  return await fastPostApi(`${API_URL}/knowledge/doc/leftspace`)
}

export async function delKnowledgeDoc (docId) {
  return await fastPostApi(`${API_URL}/knowledge/docs/del`, {}, { doc_id: docId })
}

export async function uploadKnowledgeDoc (sayid, file) {
  return await fastCreateApi(axios.post(`${API_URL}/knowledge/doc/upload`, file, {
    headers: {
      ...fastBuildHeader(), 'Content-Type': file?.type,
    }, params: {
      say_id: sayid,
    },
  }))
}

export async function uploadOaiFile (file) {
  return await fastCreateApi(axios.post(`${API_URL}/asst/oai/files/upload`, file, {
    headers: {
      ...fastBuildHeader(), 'Content-Type': file?.type,
    },
  }))
}

export async function deleteOaiFile (fileId) {
  return await fastDeleteApi(`${API_URL}/asst/oai/files/delete?file_id=${fileId}`)
}

export async function getKnowledgeCustomerAllDocs (sayid, page = 1, pageSize = 10, docNameLike = '') {
  if (docNameLike.trim().length === 0) docNameLike = null
  return await fastGetApi(`${API_URL}/knowledge/customer/doc/all`, {
    say_id: sayid, doc_input: docNameLike, page: page, page_size: pageSize,
  })
}

export async function editUserProfile (nickname, file) {
  return await fastCreateApi(axios.post(`${API_URL}/customer/profile/edit`, file, {
    headers: {
      ...fastBuildHeader(), 'Content-Type': file?.type,
    }, params: {
      nickname: nickname,
    },
  }))
}

export async function createBlueprint (data) {
  return await fastPostApi(`${API_URL}/blueprint/create`, {}, data)
}

export async function deleteBlueprint (sn) {
  return await fastDeleteApi(`${API_URL}/blueprint/delete?sn=${sn}`)
}

export async function getMyBlueprintList () {
  return await fastGetApi(`${API_URL}/blueprint/list`)
}

export async function getBlueprint (sn) {
  return await fastGetApi(`${API_URL}/blueprint/query`, { sn: sn })
}

export async function getBlueprintPublic (sn) {
  return await fastGetApi(`${API_URL}/blueprint/public`, { sn: sn })
}

export async function updateBlueprint (sn, data) {
  return await fastPutApi(`${API_URL}/blueprint/update`, { sn: sn }, data)
}

export async function createBlueprintInstance (class_sn) {
  return await fastPostApi(`${API_URL}/blueprint/instance/create`, { class_sn: class_sn })
}

export async function getBpinstShare (share_sn) {
  return await fastGetApi(`${API_URL}/blueprint/instance/share`, { share: share_sn })
}

export async function runBlueprintInstance (sn) {
  return await fastPostApi(`${API_URL}/blueprint/instance/run`, { sn: sn })
}

export async function sumbitFieldToBpInst (sn, chain_id, field_name, value) {
  return await fastCreateApi(axios.post(`${API_URL}/blueprint/instance/run/submit`, value, {
    headers: fastBuildHeader(), params: {
      sn: sn, chain_id: chain_id, field_name: field_name,
    },
  }))
}

export async function getChatListByChatLogsV2 (count = -1) {
  return await fastGetApi(`${API_URL}/brain/chat/list-by-chat-logs-v2`, { count: count })
}

export async function getChatLogsV2 (sayid, count = 50) {
  return await fastGetApi(`${API_URL}/chat/topic/chats/action/list-v2`, {
    say_id: sayid, page_count: count, is_asc: false,
  })
}

export async function speechToText (sayid, speech_file, format = 'pcm', rate = 16000, channel = 1) {
  return await fastCreateApi(axios.post(`${API_URL}/chat/speech_to_text`, speech_file, {
    headers: fastBuildHeader(), params: {
      format: format, rate: rate, channel: channel, say_id: sayid,
    },
  }))
}

export async function sendSmsVerifyCode (phone) {
  return await fastPostApi(`${API_URL}/customer/sms`, {}, { phone: phone })
}

export async function loginBySmsVerifyCode (phone, smsCode) {
  return await fastPostApi(`${API_URL}/customer/login-sms`, {
    phone: phone, sms_code: smsCode,
  })
}

export async function logout () {
  return await fastGetApi(`${API_URL}/customer/logout`)
}

export async function fastRegisterAccount (phone, smsCode, passwd) {
  return await fastPostApi(`${API_URL}/customer/register-by-phone`, {}, {
    nick_name: '真我用户', password: passwd, confirm_password: passwd, phone: phone, sms_verify_code: smsCode,
  })
}

export async function editAvatarByAI (sayid, name = '', settings = '') {
  return await fastPostApi(`${API_URL}/brain/avatar/edit-by-ai`, { say_id: sayid }, {
    say_id: sayid, name: name, settings: settings,
  })
}

export async function editAvatar (sayid, file) {
  return await fastCreateApi(axios.post(`${API_URL}/brain/avatar/edit`, file, {
    headers: {
      ...fastBuildHeader(), 'Content-Type': file?.type,
    }, params: {
      say_id: sayid,
    },
  }))
}

export async function setBrainInfo (sayid, dict = {}) {
  return await fastPostApi(`${API_URL}/brain/set/branch/info`, {}, { ...dict, say_id: sayid })
}

export async function getBrainTemplateList () {
  return await fastPostApi(`${API_URL}/brain/template/list`)
}

export async function creatBrainByTemplate (templateId = 0) {
  return await fastPostApi(`${API_URL}/brain/template/create`, {}, { template_id: templateId })
}

export async function creatBrainByAi (name, desc) {
  return await fastPostApi(`${API_URL}/brain/create-by-ai`, {}, { name: name, settings: desc })
}

export async function deleteBrain (sayid) {
  return await fastPostApi(`${API_URL}/brain/branch/del`, { say_id: sayid })
}

export async function getSchemaList (type) {
  return await fastGetApi(`${API_URL}/brain/branch/schema/list`, { type: type })
}

export async function getAsstOaiAll () {
  return await fastGetApi(`${API_URL}/asst/oai/all`)
}

export async function getAsstOaiOne (asstId) {
  return await fastGetApi(`${API_URL}/asst/oai/retrieve`, { asstid: asstId })
}

export async function getCustomPlazaMembers (plazaId, page_index = 0, page_count = 100) {
  return await fastGetApi(`${API_URL}/get_custom_plaza`, { plaza_id: plazaId, page_index: page_index, page_count: page_count })
}

export async function tempSaveAccessToken () {
  return await fastPostApi(`${API_URL}/icrd/temp-save/access-token`)
}
